import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LabRequisitionService, UserService } from 'src/app/services';
import { AccessUserInfo, UserDetail } from 'src/app/models';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';

@Component({
  selector: 'bart-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: ['./cancel.component.scss']
})
export class CancelComponent implements OnInit {
  RequisitionData: any;
  radioButtons: any[] = [{ name: 'Container not viable', key: 'reason_one' }, { name: 'Request canceled', key: 'reason_two' }];
  reasonForCancel : any;
  isValid:boolean=true;
  public userInfo: UserDetail;
  constructor(
    private _dynamicDailogConfig : DynamicDialogConfig,
    private _dynamicDialogRef: DynamicDialogRef,
    private _requisitionService : LabRequisitionService,
    private _userService:UserService
  ) { }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.RequisitionData = this._dynamicDailogConfig.data.data;
  }
  cancelRequisition(){
   
   let cancelRequisitionParams ={
    CANCELLABREQUISITION: 
    {
        UserName:this.userInfo.userName, 
        LabRequisitionID:this.RequisitionData.LabRequisitionID ,
        CancellationReason:this.reasonForCancel.name
        
    }
  }
  this._requisitionService.cancelLabRequisition(cancelRequisitionParams).subscribe(res =>{
    if(res)
    {
      this.isValid=res[0].IsCancelled;
    }
    if(this.isValid)
    {
      this._dynamicDialogRef.close(true);
    }
    
  })
  //#region User Action Audit
  this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.BUTTON_CLICKED,
    screenName: ScreenName.CONFIRM_CANCELLATION,
    screenPath: location.pathname,
    key: "LabRequisitionID",
    value: this.RequisitionData.LabRequisitionID  ,
    eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_CANCEL_REQUSITION_POPUP_SAVE_CLICKED
  });
  //#endregion  
  }
  closePopup(){
    if(!this.isValid)
    {
      this._dynamicDialogRef.close(true)
    }
    else{
      this._dynamicDialogRef.close(false)
    }
    //#region User Action Audit
   this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.BUTTON_CLICKED,
    screenName: ScreenName.CONFIRM_CANCELLATION,
    screenPath: location.pathname,
    key: "LabRequisitionID",
    value: this.RequisitionData.LabRequisitionID ,
    eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_CANCEL_REQUSITION_POPUP_CANCEL_CLICKED
  });
  //#endregion
   }
}
